/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_attachment_incidents__incident_id__attachments_post } from '../models/Body_upload_attachment_incidents__incident_id__attachments_post';
import type { IncidentAttachmentCreate } from '../models/IncidentAttachmentCreate';
import type { IncidentAttachmentRead } from '../models/IncidentAttachmentRead';
import type { IncidentCloseRequest } from '../models/IncidentCloseRequest';
import type { IncidentCreate } from '../models/IncidentCreate';
import type { IncidentHistoryRead } from '../models/IncidentHistoryRead';
import type { IncidentMetrics } from '../models/IncidentMetrics';
import type { IncidentNoteCreate } from '../models/IncidentNoteCreate';
import type { IncidentNoteRead } from '../models/IncidentNoteRead';
import type { IncidentRead } from '../models/IncidentRead';
import type { IncidentReopenRequest } from '../models/IncidentReopenRequest';
import type { IncidentStatusUpdate } from '../models/IncidentStatusUpdate';
import type { IncidentSummary } from '../models/IncidentSummary';
import type { IncidentTimeline } from '../models/IncidentTimeline';
import type { IncidentUpdate } from '../models/IncidentUpdate';
import type { PaginatedResponse_IncidentRead_ } from '../models/PaginatedResponse_IncidentRead_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IncidentsService {
    /**
     * List Incidents
     * @returns PaginatedResponse_IncidentRead_ Successful Response
     * @throws ApiError
     */
    public static listIncidentsIncidentsGet({
        status,
        severity,
        priority,
        limit = 20,
        offset,
        sort,
        q,
    }: {
        status?: (string | null),
        severity?: (string | null),
        priority?: (string | null),
        limit?: number,
        offset?: number,
        sort?: (string | null),
        q?: (string | null),
    }): CancelablePromise<PaginatedResponse_IncidentRead_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/incidents',
            query: {
                'status': status,
                'severity': severity,
                'priority': priority,
                'limit': limit,
                'offset': offset,
                'sort': sort,
                'q': q,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Incident
     * @returns IncidentRead Successful Response
     * @throws ApiError
     */
    public static createIncidentIncidentsPost({
        requestBody,
    }: {
        requestBody: IncidentCreate,
    }): CancelablePromise<IncidentRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/incidents',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Incident Summary
     * @returns IncidentSummary Successful Response
     * @throws ApiError
     */
    public static incidentSummaryIncidentsSummaryGet(): CancelablePromise<IncidentSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/incidents/summary',
        });
    }
    /**
     * Incident Metrics
     * @returns IncidentMetrics Successful Response
     * @throws ApiError
     */
    public static incidentMetricsIncidentsMetricsGet(): CancelablePromise<IncidentMetrics> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/incidents/metrics',
        });
    }
    /**
     * Get Incident
     * @returns IncidentRead Successful Response
     * @throws ApiError
     */
    public static getIncidentIncidentsIncidentIdGet({
        incidentId,
    }: {
        incidentId: string,
    }): CancelablePromise<IncidentRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/incidents/{incident_id}',
            path: {
                'incident_id': incidentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Incident
     * @returns IncidentRead Successful Response
     * @throws ApiError
     */
    public static updateIncidentIncidentsIncidentIdPut({
        incidentId,
        requestBody,
    }: {
        incidentId: string,
        requestBody: IncidentUpdate,
    }): CancelablePromise<IncidentRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/incidents/{incident_id}',
            path: {
                'incident_id': incidentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Incident
     * @returns void
     * @throws ApiError
     */
    public static deleteIncidentIncidentsIncidentIdDelete({
        incidentId,
    }: {
        incidentId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/incidents/{incident_id}',
            path: {
                'incident_id': incidentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Escalation Rules
     * @returns any Successful Response
     * @throws ApiError
     */
    public static escalationRulesIncidentsEscalationRulesGet(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/incidents/escalation-rules',
        });
    }
    /**
     * Incident Timeline
     * @returns IncidentTimeline Successful Response
     * @throws ApiError
     */
    public static incidentTimelineIncidentsIncidentIdTimelineGet({
        incidentId,
    }: {
        incidentId: string,
    }): CancelablePromise<IncidentTimeline> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/incidents/{incident_id}/timeline',
            path: {
                'incident_id': incidentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Incident Status
     * @returns IncidentRead Successful Response
     * @throws ApiError
     */
    public static updateIncidentStatusIncidentsIncidentIdStatusPatch({
        incidentId,
        requestBody,
    }: {
        incidentId: string,
        requestBody: IncidentStatusUpdate,
    }): CancelablePromise<IncidentRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/incidents/{incident_id}/status',
            path: {
                'incident_id': incidentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Close Incident
     * @returns IncidentRead Successful Response
     * @throws ApiError
     */
    public static closeIncidentIncidentsIncidentIdClosePost({
        incidentId,
        requestBody,
    }: {
        incidentId: string,
        requestBody: IncidentCloseRequest,
    }): CancelablePromise<IncidentRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/incidents/{incident_id}/close',
            path: {
                'incident_id': incidentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reopen Incident
     * @returns IncidentRead Successful Response
     * @throws ApiError
     */
    public static reopenIncidentIncidentsIncidentIdReopenPost({
        incidentId,
        requestBody,
    }: {
        incidentId: string,
        requestBody: IncidentReopenRequest,
    }): CancelablePromise<IncidentRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/incidents/{incident_id}/reopen',
            path: {
                'incident_id': incidentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Note
     * @returns IncidentNoteRead Successful Response
     * @throws ApiError
     */
    public static addNoteIncidentsIncidentIdNotesPost({
        incidentId,
        requestBody,
    }: {
        incidentId: string,
        requestBody: IncidentNoteCreate,
    }): CancelablePromise<IncidentNoteRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/incidents/{incident_id}/notes',
            path: {
                'incident_id': incidentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Notes
     * @returns IncidentNoteRead Successful Response
     * @throws ApiError
     */
    public static listNotesIncidentsIncidentIdNotesGet({
        incidentId,
    }: {
        incidentId: string,
    }): CancelablePromise<Array<IncidentNoteRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/incidents/{incident_id}/notes',
            path: {
                'incident_id': incidentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List History
     * @returns IncidentHistoryRead Successful Response
     * @throws ApiError
     */
    public static listHistoryIncidentsIncidentIdHistoryGet({
        incidentId,
    }: {
        incidentId: string,
    }): CancelablePromise<Array<IncidentHistoryRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/incidents/{incident_id}/history',
            path: {
                'incident_id': incidentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Attachments
     * @returns IncidentAttachmentRead Successful Response
     * @throws ApiError
     */
    public static listAttachmentsIncidentsIncidentIdAttachmentsGet({
        incidentId,
    }: {
        incidentId: string,
    }): CancelablePromise<Array<IncidentAttachmentRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/incidents/{incident_id}/attachments',
            path: {
                'incident_id': incidentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Attachment
     * @returns IncidentAttachmentRead Successful Response
     * @throws ApiError
     */
    public static uploadAttachmentIncidentsIncidentIdAttachmentsPost({
        incidentId,
        formData,
    }: {
        incidentId: string,
        formData: Body_upload_attachment_incidents__incident_id__attachments_post,
    }): CancelablePromise<IncidentAttachmentRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/incidents/{incident_id}/attachments',
            path: {
                'incident_id': incidentId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Attachment Url
     * @returns IncidentAttachmentRead Successful Response
     * @throws ApiError
     */
    public static addAttachmentUrlIncidentsIncidentIdAttachmentsUrlPost({
        incidentId,
        requestBody,
    }: {
        incidentId: string,
        requestBody: IncidentAttachmentCreate,
    }): CancelablePromise<IncidentAttachmentRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/incidents/{incident_id}/attachments/url',
            path: {
                'incident_id': incidentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Escalate
     * @returns IncidentRead Successful Response
     * @throws ApiError
     */
    public static escalateIncidentsIncidentIdEscalatePost({
        incidentId,
        level,
    }: {
        incidentId: string,
        level?: (number | null),
    }): CancelablePromise<IncidentRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/incidents/{incident_id}/escalate',
            path: {
                'incident_id': incidentId,
            },
            query: {
                'level': level,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
